
import Vue, { PropType } from 'vue'

import LogTimelineItem from '@/ui/components/timeline/LogTimelineItem.vue'

import LogItem from '@/models/LogItem'

import { sortByDate } from '@/helpers/sorters'
import { formatDate } from '@/helpers/formatters'

export default Vue.extend({
  components: {
    LogTimelineItem,
  },
  props: {
    // plant: Object,
    value: {
      type: Array as PropType<Array<LogItem>>,
      default: (): Array<LogItem> => [],
    },
    category: String,
    hideFilter: Boolean,
    hidePlants: Boolean,
    maxItems: {
      type: Number,
      default: 20,
    },
    moreItemsCount: {
      type: Number,
      default: 10,
    },
  },
  data: () => ({
    categoryFilter: [] as string[],
    addItems: 0,
  }),
  computed: {
    isSmall(): boolean {
      return this.$vuetify.breakpoint.xsOnly
    },
    hasMoreItems(): boolean {
      return this.logItems.length > this.visibleItems
    },
    visibleItems(): number {
      return this.maxItems + this.addItems
    },
    categories(): string[] {
      return [...new Set<string>(this.value.map((l: LogItem) => l.category))]
    },
    limitedLogItems(): LogItem[] {
      return this.logItems.slice(0, this.visibleItems)
    },
    logItems(): LogItem[] {
      // return (this.category ? this.plant[this.category + 's'] : this.plant.log)
      return this.value
        .filter((l: LogItem) =>
          this.category
            ? l.category === this.category
            : this.categoryFilter.length < 1 ||
              this.categoryFilter.includes(l.category)
        )
        .sort(sortByDate<LogItem>(true))
      // .sort((a: LogItem, b: LogItem) => {
      //   return a.date < b.date
      //     ? 1
      //     : a.date > b.date
      //       ? -1
      //       : (b.createdAt ? b.createdAt.getTime() : Date.now()) - (a.createdAt ? a.createdAt.getTime() : Date.now())
      // })
    },
  },
  methods: {
    formatDate: formatDate,
    addMoreItems() {
      this.addItems += this.moreItemsCount
    },
  },
})
